import { render } from "./AccessControlList.vue?vue&type=template&id=9f33ba6c&scoped=true"
import script from "./AccessControlList.vue?vue&type=script&lang=js"
export * from "./AccessControlList.vue?vue&type=script&lang=js"

import "./AccessControlList.vue?vue&type=style&index=0&id=9f33ba6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f33ba6c"]])

export default __exports__